import { render } from "./DataAsalPendaftarView.vue?vue&type=template&id=e6029840"
import script from "./DataAsalPendaftarView.vue?vue&type=script&lang=js"
export * from "./DataAsalPendaftarView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__